import { useAppSelector } from '@frontend/common';
import { useModals } from '@frontend/modal';
import { changeFilter, listStore, useAccountRepository } from '@frontend/repository';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';

import { useAppDispatch } from '../../../redux/store';

export const useSendCleanLaundry = () => {
    const { openModal } = useModals();
    const { currentAccount } = useAccountRepository();
    const navigate = useNavigate();
    const location = useLocation();
    const [selectedSpot, setSelectedSpot] = useState<string | null>(null);
    const dispatch = useAppDispatch();
    const list = useAppSelector(useSelector, listStore);
    const listId = 'send-clean-laundry-transactions';
    useEffect(() => {
        const currentFilter = list[listId]?.filter?.spot_id;
        if (!list[listId] || currentFilter === selectedSpot) return;
        dispatch(changeFilter({ listId, key: 'spot_id', value: selectedSpot }));
    }, [dispatch, selectedSpot, list]);

    return {
        openModal,
        currentAccount,
        navigate,
        location,
        selectedSpot,
        setSelectedSpot
    };
};
